var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVenus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: 48,
    height: 48,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#venus-svg-gradient)",
    d: "M47.19 12.07 29.623 42.497a6.048 6.048 0 0 1-10.466 0l-3.08-5.33a.063.063 0 0 1 .1-.074 5.06 5.06 0 0 0 6.362.61 5.064 5.064 0 0 0 1.567-1.664l14.706-25.496a5.06 5.06 0 0 0-3.086-7.418.062.062 0 0 1 0-.125h6.234a6.047 6.047 0 0 1 5.23 9.07ZM26.394 3h-6.09a.062.062 0 0 0 0 .118 3.055 3.055 0 0 1 1.552 4.364l-8.877 15.354a3.062 3.062 0 0 1-4.67.736.062.062 0 0 0-.04-.025.062.062 0 0 0-.059.099l3.117 5.411a3.99 3.99 0 0 0 6.913 0L29.854 8.984A3.99 3.99 0 0 0 26.394 3ZM5.255 3a5.255 5.255 0 1 0 4.857 3.243A5.248 5.248 0 0 0 5.255 3Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "venus-svg-gradient",
    x1: 47.386,
    x2: -7.499,
    y1: 36.644,
    y2: -0.628,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5433FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#20BDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5CFFA2"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVenus);
export default __webpack_public_path__ + "static/media/venus.0ac6537b6bf993b32b4d287629f62d79.svg";
export { ForwardRef as ReactComponent };